import React, {useState} from 'react';
import axios from 'axios';

const skillBg = {
  backgroundColor: 'var(--about-bg)'
}
const inputBg = {
  backgroundColor: 'var(--contact-text)'
};
const Contact = (props) => {
  const [darkToggle, setDarkToggle] = React.useState(false);
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const emailservice = (name, surname, email, message) => {
    const url = "http://localhost:7003/email";
    const body = {
      'name': name,
      'surname': surname,
      'email': email,
      'message': message,
    }

    try {
      const response = axios.post(url, body, {
        headers: { 'Content-Type': 'application/json'}},);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  }

  const sendEmail = (e) => {
    e.preventDefault();
    console.log(name, surname, email, message);

    if(name && surname && email && message) {
      // emailservice(name, surname, email, message);
    }
  };

  return (
    <section className={`w-full glass flex flex-col gap-4 px-4 py-16`} id={props.id}>

      <div className='card shadow-2xl text-center flex mx-auto justify-center lg:flex-column w-11/12 rounded glass'>
        <div className='rounded' style={skillBg}>
          <h2 className="p-5 text-4xl font-bold text-white">
            Let's Talk.
          </h2>
          <p className="font-bold text-white">
            Get in touch via the form below, or emailing fm.raphalalani@gmail.com
          </p>
        </div>
      </div>

      <form
        className="card shadow-2xl flex mx-auto justify-center lg:flex-column p-4 w-11/12 rounded bg-blue-300"
        action="https://formsubmit.co/fm.raphalalani@gmail.com"
        method="POST"
        
      >
        <div className="form-control w-full max-w-full flex flex-column flex-wrap gap-2 mt-4">
          <label className="label">
            <span className="label-text text-center text-2xl font-bold text-white">Name<span className='text-red-700'>*</span>:</span>
          </label>
          <input required
            type="text"
            placeholder="Enter your name"
            name="name"
            
            className="input input-md input-bordered w-full max-w-full rounded-lg"
            style={inputBg}
          />
        </div>
        <div className="form-control w-full max-w-full flex flex-column flex-wrap gap-2 mt-4">
          <label className="label">
            <span className="label-text text-center text-2xl font-bold text-white">Surname:</span>
          </label>
          <input
            type="text"
            placeholder="Enter your surname"
            name="surname"
            className="input input-bordered input-md w-full max-w-full rounded-lg"
            style={inputBg}
          />
          <input type="hidden" name="_template" value="table"></input>
        </div>
        <div className="form-control w-full max-w-full flex flex-column flex-wrap gap-2 mt-4">
          <label className="label">
            <span className="label-text text-center text-2xl font-bold text-white">
              Email Address<span className='text-red-700'>*</span>:
            </span>
          </label>
          <input required
            type="email"
            placeholder="Enter your email address"
            name="email"
            className="input input-md input-bordered w-full max-w-full rounded-lg"
            style={inputBg}
          />
          <input
            type="hidden"
            name="_subject"
            value="Professional Website Contact Form Request"
          ></input>
        </div>
        <div className="form-control w-full max-w-full flex flex-column flex-wrap gap-2 mt-4">
          <label className="label w-full">
            <span className="label-text text-center text-2xl font-bold text-white">Message<span className='text-red-700'>*</span>:</span>
          </label>
          <textarea required
            className="textarea textarea-bordered textarea-md h-32 w-full rounded-lg"
            name="message"
            placeholder="Enter your message"
            style={inputBg}
          ></textarea>
          <input type="hidden" name="_captcha" value="false"></input>
        </div>
        <button 
          className="btn p-2 bg-lg bg-green-800 rounded mt-4 font-bold text-white"
          type="submit"
        >
          Send Message
        </button>
      </form>
    </section>
  )
}

export default Contact;